
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TasaTable() {
  const [tasas, setTasas] = useState([]);
  const [filteredTasas, setFilteredTasas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('id');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    fetchTasas();
  }, []);

  useEffect(() => {
    filterAndSortTasas();
  }, [searchTerm, tasas, sortColumn, sortDirection]);

  const fetchTasas = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/tasas');
      setTasas(response.data);
      setFilteredTasas(response.data);
    } catch (err) {
      setError('Error al cargar las tasas. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const filterAndSortTasas = () => {
    let filtered = tasas.filter(tasa =>
      tasa.descripcion.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredTasas(sorted);
    setCurrentPage(1);
  };

  const handleDeleteTasa = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta tasa?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/tasas/${id}`);
        fetchTasas();
      } catch (err) {
        setError('Error al eliminar la tasa. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSort = (column) => {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortColumn(column);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTasas.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredTasas.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Tasas</h1>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
        <div className="p-4 flex justify-between items-center bg-gray-50">
          <h2 className="text-xl font-semibold">Tabla de Tasas</h2>
          <Link to="/home/tasas/add" className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
            <FaPlus className="mr-2" /> Añadir Tasa
          </Link>
        </div>
        <div className="p-4 flex items-center bg-gray-100">
          <FaSearch className="mr-2" />
          <input
            type="text"
            placeholder="Buscar por Descripción"
            className="border p-2 rounded w-64"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-blue-500 text-white">
              <tr>
                {['id', 'descripcion', 'aplicacion', 'padron', 'recaudador', 'importe'].map(col => (
                  <th key={col} className="px-6 py-3 cursor-pointer" onClick={() => handleSort(col)}>
                    {col.charAt(0).toUpperCase() + col.slice(1)} {sortColumn === col && (sortDirection === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                  </th>
                ))}
                <th className="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems.map((tasa) => (
                <tr key={tasa.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">{tasa.id}</td>
                  <td className="px-6 py-4">{tasa.descripcion}</td>
                  <td className="px-6 py-4">{tasa.aplicacion}</td>
                  <td className="px-6 py-4">{tasa.padron}</td>
                  <td className="px-6 py-4">{tasa.recaudador}</td>
                  <td className="px-6 py-4">{tasa.importe}</td>
                  <td className="px-6 py-4 flex space-x-2">
                    <Link to={`/home/tasas/${tasa.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                    <Link to={`/home/tasas/edit/${tasa.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                    <button onClick={() => handleDeleteTasa(tasa.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-center space-x-2 mt-4">
          {[...Array(totalPages)].map((_, index) => (
            <button key={index} onClick={() => paginate(index + 1)} className={`px-4 py-2 border rounded ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}>{index + 1}</button>
          ))}
        </div>
      </div>
    </div>
  );
}

/*

import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TasaTable() {
  const [tasas, setTasas] = useState([]);
  const [filteredTasas, setFilteredTasas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('id');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    fetchTasas();
  }, []);

  useEffect(() => {
    filterAndSortTasas();
  }, [searchTerm, tasas, sortColumn, sortDirection]);

  const fetchTasas = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/tasas');
      setTasas(response.data);
      setFilteredTasas(response.data);
    } catch (err) {
      setError('Error al cargar las tasas. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const filterAndSortTasas = () => {
    let filtered = tasas.filter(tasa =>
      tasa.descripcion.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredTasas(sorted);
    setCurrentPage(1);
  };

  const handleDeleteTasa = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta tasa?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/tasas/${id}`);
        fetchTasas();
      } catch (err) {
        setError('Error al eliminar la tasa. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSort = (column) => {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortColumn(column);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTasas.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredTasas.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Tasas</h1>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
        <div className="p-4 flex justify-between items-center bg-gray-50">
          <h2 className="text-xl font-semibold">Tabla de Tasas</h2>
          <Link to="/home/tasas/add" className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
            <FaPlus className="mr-2" /> Añadir Tasa
          </Link>
        </div>
        <div className="p-4 flex items-center bg-gray-100">
          <FaSearch className="mr-2" />
          <input
            type="text"
            placeholder="Buscar por Descripción"
            className="border p-2 rounded w-64"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                {['id', 'descripcion', 'aplicacion', 'padron', 'recaudador', 'importe'].map(col => (
                  <th key={col} className="px-6 py-3 cursor-pointer" onClick={() => handleSort(col)}>
                    {col.charAt(0).toUpperCase() + col.slice(1)} {sortColumn === col && (sortDirection === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                  </th>
                ))}
                <th className="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems.map((tasa) => (
                <tr key={tasa.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">{tasa.id}</td>
                  <td className="px-6 py-4">{tasa.descripcion}</td>
                  <td className="px-6 py-4">{tasa.aplicacion}</td>
                  <td className="px-6 py-4">{tasa.padron}</td>
                  <td className="px-6 py-4">{tasa.recaudador}</td>
                  <td className="px-6 py-4">{tasa.importe}</td>
                  <td className="px-6 py-4 flex space-x-2">
                    <Link to={`/home/tasas/${tasa.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                    <Link to={`/home/tasas/edit/${tasa.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                    <button onClick={() => handleDeleteTasa(tasa.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-center space-x-2 mt-4">
          {[...Array(totalPages)].map((_, index) => (
            <button key={index} onClick={() => paginate(index + 1)} className={`px-4 py-2 border rounded ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}>{index + 1}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/